// frontend/src/features/livestock/wheelDelta.ts
// A wheel event's movement in pixels. Firefox (and some mice) report lines or
// pages (deltaMode 1 or 2) rather than pixels, which would move a pan or zoom
// by a few pixels a notch.

/** Pixels per line, as browsers scroll a line. */
export const WHEEL_LINE_PX = 16;

export function wheelPixels(
  event: Pick<WheelEvent, 'deltaX' | 'deltaY' | 'deltaMode'>,
  page: { width: number; height: number }
): { x: number; y: number } {
  if (event.deltaMode === 1) {
    return { x: event.deltaX * WHEEL_LINE_PX, y: event.deltaY * WHEEL_LINE_PX };
  }
  if (event.deltaMode === 2) return { x: event.deltaX * page.width, y: event.deltaY * page.height };
  return { x: event.deltaX, y: event.deltaY };
}
